import { STAKING_TOKENS, STAKING_TOKEN_NAME } from 'constants/abis/staking'

export function useStakingCurrency(currencyName: STAKING_TOKEN_NAME) {
  return STAKING_TOKENS[currencyName] || STAKING_TOKENS.default
}
